/**
 * URL Parameter Cleanup
 * Removes marketing/tracking parameters from URLs while preserving functional Shopify parameters
 */

document.addEventListener('DOMContentLoaded', function() {
  // Delay cleanup by 200ms to allow analytics tools to capture original URL
  setTimeout(function() {
    const url = new URL(window.location.href);
    const params = url.searchParams;
    
    // Allowlist of functional parameters that should be preserved
    const functionalParams = [
      // Core functionality
      'variant',
      'page',
      'q',
      'type',
      'sort_by',
      'view',
      'limit',
      
      // Shopify internal
      'section_id',
      'preview_theme_id',
      '_key',
      
      // Localization
      'locale_code',
      'country_code',
      
      // Customer/Auth
      'customer_posted',
      'return_to',
      
      // Checkout
      'discount',
      'checkout_url',
    ];
    
    // Check if a parameter should be preserved
    function shouldPreserve(paramName) {
      // Preserve exact matches
      if (functionalParams.includes(paramName)) {
        return true;
      }
      
      // Preserve filter.* parameters (collection facets)
      if (paramName.startsWith('filter.')) {
        return true;
      }
      
      // Preserve options[*] parameters (search options)
      if (/^options\[.+\]$/.test(paramName)) {
        return true;
      }
      
      return false;
    }
    
    // Collect parameters to remove
    const paramsToRemove = [];
    for (const [key] of params) {
      if (!shouldPreserve(key)) {
        paramsToRemove.push(key);
      }
    }
    
    // Remove non-functional parameters
    if (paramsToRemove.length > 0) {
      paramsToRemove.forEach(param => {
        params.delete(param);
      });
      
      // Update URL without page reload
      const cleanUrl = url.pathname + (params.toString() ? '?' + params.toString() : '') + url.hash;
      window.history.replaceState({}, '', cleanUrl);
    }
  }, 200);
});
